import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColorClassSuffix } from 'features/shared/enums/colorClassSuffix';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import styles from './dropdownActionItem.module.scss';

interface Props {
  title: string;
  icon?: IconProp;
  onClick?: () => void;
  disabled?: boolean;
  color?: ColorClassSuffix;
}

const DropdownActionItem = ({ title, icon, onClick, disabled, color }: Props) => {
  // helpers
  const getColorClass = (isIcon: boolean = false): string => {
    if (disabled) {
      return " text-default";
    }

    if (isIcon) {
      return color ? ` text-${color}` : " text-secondary";
    }

    return color ? ` text-${color}` : ""
  }

  // sub-renders
  const renderIcon = () => {
    if (icon) {
      return (
        <span className={`${styles.itemIcon}${getColorClass(true)}`}>
          <FontAwesomeIcon icon={icon} />
        </span>
      )
    }    
  }

  // render
  return (
    <Dropdown.Item
      as="div"
      disabled={disabled}
      className={styles.menuItem}
      onClick={onClick}
    >
      <div className="d-flex align-items-center">
        {renderIcon()}
        <span className={`${styles.itemText}${getColorClass()}`}>{title}</span>  
      </div>
    </Dropdown.Item>
  )
}

export default DropdownActionItem;
